import request from '@/utils/request';

// 发布
// export function versionPublish(id, options) {
//   return request({
//     url: `op/applicationeditions/${id}/release`,
//     method: 'put',
//     data: options
//   });
// }

// 发布记录
// export function versionListPage(options) {
//   return request({
//     url: '/op/applicationeditions/release/page',
//     method: 'get',
//     params: options
//   });
// }

// 编辑版本
export function updateVersion(id, options) {
  return request({
    url: '/op/applicationeditions/updateVersion/' + id,
    method: 'POST',
    data: options
  });
}
// 添加版本
export function addVersion(options) {
  return request({
    url: '/op/applicationeditions/addVersion',
    method: 'POST',
    data: options
  });
}
// 编辑应用
export function updateApp(id, options) {
  return request({
    url: '/op/appManage/updateApp/' + id,
    method: 'POST',
    data: options
  });
}
// 添加应用
export function addApp(options) {
  return request({
    url: '/op/appManage/addApp',
    method: 'POST',
    data: options
  });
}
// 应用编码
export function appCode(options) {
  return request({
    url: '/op/appManage/getAppCode',
    method: 'get',
    params: options
  });
}
// 版本的启用与禁用(批量)
export function versionStatusBatch(options) {
  return request({
    url: '/op/appManage/batchStart',
    method: 'POST',
    data: options
  });
}
// 版本的启用与禁用
export function versionStatus(id, options) {
  return request({
    url: '/op/applicationeditions/updateVersion/' + id,
    method: 'POST',
    data: options,
    ContentType: 'application/json'
  });
}
// 查询版本管理列表
export function versionList(options) {
  return request({
    url: '/op/applicationeditions/queryList',
    method: 'get',
    params: options
  });
}
// 查询版本管理列表
export function versionListPage(options) {
  return request({
    url: '/op/applicationeditions/release/page',
    method: 'get',
    params: options
  });
}
// 发布
export function versionPublish(id, options) {
  return request({
    url: `op/applicationeditions/${id}/release`,
    method: 'put',
    data: options
  });
}

// 应用下架
export function OffStatus(id, options) {
  return request({
    url: '/op/appManage/updateApp/' + id,
    method: 'POST',
    data: options,
    ContentType: 'application/json'
  });
}
// 查看应用详情
export function queryDetail(options) {
  return request({
    url: '/op/appManage/whitelist/queryDetail',
    method: 'get',
    params: options
  });
}
// 获取获取应用分类列表
export function appList(options) {
  return request({
    url: '/op/appManage/whitelist/page',
    method: 'get',
    params: options
  });
}

// 查询应用类型下拉列表
export function getAppTypeSelect(options) {
  return request({
    url: '/op/appReferencce/whitelist/getAppTypeSelect',
    method: 'get',
    params: options
  });
}
// 获取适用学科
export function getSubjects(options) {
  return request({
    url: '/op/appManage/whitelist/getSubjects',
    method: 'get',
    params: options
  });
}
// 获取适用年级
export function getGrades(options) {
  return request({
    url: '/op/appManage/whitelist/getGrades',
    method: 'get',
    params: options
  });
}
// 获取应用版本列表
export function getVersions(options) {
  return request({
    url: '/campus/apps/version/list',
    method: 'get',
    params: options
  });
}

// 版本禁用
export function versionDisable(id, typeCode) {
  return request({
    url: `/op/applicationeditions/${id}/disable?typeCode=${typeCode}`,
    method: 'put'
  });
}

// 版本启用
export function versionEnable(id, typeCode) {
  return request({
    url: `/op/applicationeditions/${id}/enable?typeCode=${typeCode}`,
    method: 'put'
  });
}
